"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LISTBOX_EVENT_REASON = void 0;
var LISTBOX_EVENT_REASON = Object.freeze({
  CLICK: 'click',
  HOVER: 'hover',
  TYPEAHEAD: 'typeahead',
  ARROW_DOWN: 'arrow down',
  ARROW_UP: 'arrow up',
  HOME: 'home',
  END: 'end',
  SPACE: 'space',
  ENTER: 'enter'
});
exports.LISTBOX_EVENT_REASON = LISTBOX_EVENT_REASON;